module.exports = __webpack_public_path__ + "static/media/05.4c2bd9bd.png";